import React from 'react';

function ProfileAddPlant(){

    return (
       
        <>

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Plant Information </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Name"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Address"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>

<div class="row">


    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Street Name"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Province"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>


<div class="row">


    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="City"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="number"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Zip Code"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>



        </>
    )
}

export default ProfileAddPlant;


